import {HistoricalPipelineColumns} from "./historicalPipelineColumns";
import {QuarterlyPipelineColumns} from './quarterlyPipelineColumn';

export class HistoricalPipeline {
    retail;
    retailSTNL;
    retailMT;
    office;
    officeSTNL;
    officeMT;
    industrial;
    industrialSTNL;
    industrialMT;
    other;
    otherSTNL;
    otherMT;
    quarterTotal;

    constructor({data, quarter}) {
        if (quarter) {
            this.quarterTotal = new QuarterlyPipelineColumns({quarter: quarter, data});
            this.retail = new QuarterlyPipelineColumns({quarter: quarter, category: 'Retail', data});
            this.retailSTNL = new QuarterlyPipelineColumns({quarter: quarter, category: 'Retail', type: 'STNL', data});
            this.retailMT = new QuarterlyPipelineColumns({quarter: quarter, category: 'Retail', type: 'MT', data});
            this.office = new QuarterlyPipelineColumns({quarter: quarter, category: 'Office', data});
            this.officeSTNL = new QuarterlyPipelineColumns({quarter: quarter, category: 'Office', type: 'STNL', data});
            this.officeMT = new QuarterlyPipelineColumns({quarter: quarter, category: 'Office', type: 'MT', data});
            this.industrial = new QuarterlyPipelineColumns({quarter: quarter, category: 'Industrial', data});
            this.industrialSTNL = new QuarterlyPipelineColumns({quarter: quarter, category: 'Industrial', type: 'STNL', data});
            this.industrialMT = new QuarterlyPipelineColumns({quarter: quarter, category: 'Industrial', type: 'MT', data});
            this.other = new QuarterlyPipelineColumns({quarter: quarter, category: 'Other', data});
            this.otherSTNL = new QuarterlyPipelineColumns({quarter: quarter, category: 'Other', type: 'STNL', data});
            this.otherMT = new QuarterlyPipelineColumns({quarter: quarter, category: 'Other', type: 'MT', data});
        } else {
            this.retail = new HistoricalPipelineColumns({category: 'Retail', data});
            this.retailSTNL = new HistoricalPipelineColumns({category: 'Retail', type: 'STNL', data});
            this.retailMT = new HistoricalPipelineColumns({category: 'Retail', type: 'MT', data});
            this.office = new HistoricalPipelineColumns({category: 'Office', data});
            this.officeSTNL = new HistoricalPipelineColumns({category: 'Office', type: 'STNL', data});
            this.officeMT = new HistoricalPipelineColumns({category: 'Office', type: 'MT', data});
            this.industrial = new HistoricalPipelineColumns({category: 'Industrial', data});
            this.industrialSTNL = new HistoricalPipelineColumns({category: 'Industrial', type: 'STNL', data});
            this.industrialMT = new HistoricalPipelineColumns({category: 'Industrial', type: 'MT', data});
            this.other = new HistoricalPipelineColumns({category: 'Other', data});
            this.otherSTNL = new HistoricalPipelineColumns({category: 'Other', type: 'STNL', data});
            this.otherMT = new HistoricalPipelineColumns({category: 'Other', type: 'MT', data});
        }
    }
}